export default __webpack_public_path__ + "static/media/DSC0299_grey.4a72a1fb.jpg";